import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionPaddings,
} from '../styles';
import { Button, Container, Heading } from './ui';

const StyledCallToAction = styled.section`
  ${sectionPaddings('45px', '90px')};
  background-color: ${brandColours.septenary};
`;

const StyledInner = styled.div`
  display: grid;
  gap: 30px;

  ${minBreakpointQuery.tiny`
    gap: 45px;
  `}

  ${minBreakpointQuery.small`
    gap: 60px;
  `}

  ${minBreakpointQuery.smedium`
    align-items: center;
    grid-template-columns: .4fr .6fr;
  `}

  ${minBreakpointQuery.medium`
    gap: 100px;
  `}

  ${minBreakpointQuery.mlarge`
    gap: 140px;
  `}

  ${minBreakpointQuery.large`
    gap: 180px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 220px;
  `}
`;

const StyledImage = styled.img`
  margin: auto;
  height: 100%;
  width: 100%;
  max-height: 400px;
  max-width: 375px;
`;

const StyledContent = styled.div``;

const StyledHeading = styled(Heading)`
  line-height: 1.4;
`;

const StyledText = styled.p`
  white-space: break-spaces;
  line-height: 1.5;
  margin-top: 20px;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}
`;

const StyledButton = styled(Button)`
  margin-top: 20px;

  ${maxBreakpointQuery.smedium`
    width: 100%;
  `}
`;

const CallToAction = ({ image, heading, text, link }) => (
  <StyledCallToAction>
    <Container>
      <StyledInner>
        <StyledImage src={image.url} alt={image.alt} loading="lazy" />
        <StyledContent>
          <StyledHeading>{heading}</StyledHeading>
          <StyledText>{text}</StyledText>
          <StyledButton to={link.pageUrl}>{link.text}</StyledButton>
        </StyledContent>
      </StyledInner>
    </Container>
  </StyledCallToAction>
);

export default CallToAction;
